import Intro from './intro';

export default Intro;